module.exports = __webpack_public_path__ + "static/media/santorini-hair-e-makeup.0d1a5cba.png";